<template>
  <div ref="fileManager2" id="fileManager2" v-bind:class="{'fileManager2Bajo': windowWidthEsBaja, 'fileManager2Alto': !windowWidthEsBaja}">
        <b-modal
          ref="modal-agregar-carpeta"
          id="modal-agregar-carpeta"
          modal-class="modal-primary"
          centered
          title="Ingrese el nombre de su nueva carpeta"
        >
          <div class="con-exemple-prompt">
              <b-input
              placeholder="Nombre de la Carpeta"
              v-model="newFolderName"
              v-validate="'required|min:3|max:200'"
              :danger="errors.has('carpeta')"
              name="carpeta"
              class="w-full"
              max="200"/>
              <span class="text-danger text-sm"  v-show="errors.has('carpeta')">{{  errors.first('carpeta') }}</span>
          </div>

          <template #modal-footer>
            <div style="display:flex; width: fit-content; margin: auto;">
              <b-button @click="hayError()" variant="primary">Guardar</b-button>
              <b-button @click="hideModal('modal-agregar-carpeta')" variant="secondary" class="ml-1">Cancelar</b-button>
            </div>
          </template>
        </b-modal>

<!--    <vs-prompt-->
<!--      title="Ingrese el nombre de su nueva carpeta"-->
<!--      :buttons-hidden="true"-->
<!--      :active.sync="promptNewFolder"-->
<!--      @close="newFolderName=''"-->
<!--      v-on:submit.prevent="onSubmit">-->
<!--      <div class="con-exemple-prompt">-->
<!--            <vs-input-->
<!--            placeholder="Nombre de la Carpeta"-->
<!--            v-model="newFolderName"-->
<!--            v-validate="'required|min:3'"-->
<!--            :danger="errors.has('carpeta')"-->
<!--            name="carpeta"-->
<!--            class="w-full" />-->
<!--            <span class="text-danger text-sm"  v-show="errors.has('carpeta')">{{  errors.first('carpeta') }}</span>-->
<!--      </div>-->
<!--      <div style="display:flex; width: fit-content; margin: auto;" class="mt-3">-->
<!--        <vs-button @click="hayError()" color="primary">Guardar</vs-button>-->
<!--        <vs-button @click="promptNewFolder = false" color="gray" class="ml-2">Cancelar</vs-button>-->
<!--      </div>-->
<!--    </vs-prompt>-->

        <b-modal
          ref="modal-eliminar-carpeta"
          id="modal-eliminar-carpeta"
          modal-class="modal-primary"
          centered
          title="¿Seguro de eliminar?"
        >
          <div class="con-exemple-prompt">
            <div>
              <div class="vx-card__title text-center">
                <p>Si desea continuar no podrá deshacer esta acción, se eliminarán los controles relacionados, ¿Está seguro de continuar?</p>
              </div>
            </div>
          </div>

          <template #modal-footer>
            <div style="display:flex; width: fit-content; margin: auto;">
              <b-button @click="deleteActiveItem()" variant="primary">Sí</b-button>
              <b-button @click="hideModal('modal-eliminar-carpeta')" variant="secondary" class="ml-1">Cancelar</b-button>
            </div>
          </template>
        </b-modal>

<!--    <vs-prompt-->
<!--      title="Eliminar carpeta"-->
<!--      :buttons-hidden="true"-->
<!--      :active.sync="promptSureDelete"-->
<!--      @close="promptSureDelete = false"-->
<!--      v-on:submit.prevent="onSubmit">-->
<!--      <div v-if="activeItem" class="con-exemple-prompt" style="text-align: center;">-->
<!--        <p>¿Está seguro de eliminar {{ activeItem.innerText }}?</p>-->
<!--      </div>-->
<!--      <div style="display:flex; width: fit-content; margin: auto;" class="mt-3">-->
<!--        <vs-button @click="deleteActiveItem()" color="primary">Sí, estoy seguro</vs-button>-->
<!--        <vs-button @click="promptSureDelete = false" color="gray" class="ml-2">Cancelar</vs-button>-->
<!--      </div>-->
<!--    </vs-prompt>-->

    <div id="fileManagerHeader" class="d-flex align-items-center custom-list-container">
        <div class="header-option" style="display: flex; padding: 5px;" @click="volver()" v-b-tooltip.top="'Volver un directorio atrás'">
          <p><font-awesome-icon style="color: background: #1D3662!important;" icon="arrow-left"/></p><p style="padding-left:5px; font-weight: bold;"></p>
        </div>
        <div class="header-option" style="display: flex; padding: 5px 5px 5px 15px;" @click="refreshFolder()" v-b-tooltip.top="'Actualizar directorio'">
          <p><font-awesome-icon style="color: background: #1D3662!important;" icon="sync"/></p><p style="padding-left:5px; font-weight: bold;"></p>
        </div>
        <div class="custom-file header-option ml-1 mr-1 d-flex align-items-center" style="width: fit-content;">
          <input type="file" name="archivo" data-max-size="2000000" @change="cargarFilesInputSelect($event, $event.target)" id="archivo" class="custom-file-input" style="display: none;" multiple>
          <label for="archivo" class="" style="padding: 0px 5px 5px 15px; display: flex; width: fit-content; cursor: pointer; padding: 0;" v-b-tooltip.top="'Agregar documentos'">
              <feather-icon icon="FilePlusIcon" size="20" style="color: white"></feather-icon>
          </label>
        </div>
        <div class="header-option mr-1" style="display: flex; padding: 5px 5px 5px 15px;" @click="showModalAgregarCarpeta" v-b-tooltip.top="'Agregar directorio'">
          <p>
            <font-awesome-icon style="color: background: #1D3662!important;" icon="folder-plus"/>
          </p>
        </div>

        <div v-if="activeItem" class="header-option" style="display: flex; padding: 5px 5px 5px 15px;" @click="showModalDeleteCarpeta()" v-b-tooltip.top="'Eliminar'">
          <p><font-awesome-icon style="color: background: #1D3662!important;" icon="trash"/></p><p style="padding-left:5px; font-weight: bold;"></p>
        </div>
        <div v-if="activeItem && activeItem.getAttribute('token')!=null" class="header-option" style="display: flex; padding: 5px 5px 5px 15px;" @click="openSelectedFile()" v-b-tooltip.top="'Abrir documento en nueva ventana'">
          <p><font-awesome-icon style="color: background: #1D3662!important;" icon="external-link-alt"/></p><p style="padding-left:5px; font-weight: bold;"></p>
        </div>
    </div>
    <div id="fileManagerContent" class="custom-list-container">
      <!-- <div id="fileManagerFilesTree">
        <v-tree ref='tree' :data='treeData' :tpl='tpl' :selectAlone='true' :key="treeKey"/>
      </div> -->
      <div id="fileManagerFilesRegion">
        <div id="fileManagerFilesRegionBreadcumb" style="border-top: none;" class="d-flex align-items-center">
          <p style="width: 70%; font-weight: bold;">Nombre</p>
          <p v-if="!windowWidthEsBaja" style="width: 15%; padding-right: 25px; text-align: right; font-weight: bold">Creado</p>
          <p v-if="!windowWidthEsBaja" style="width: 15%; padding-right: 25px; text-align: right; font-weight: bold">Tamaño</p>
        </div>
        <div id="fileManagerFilesRegionFiles" :style="{height: String(filesRegionHeight)+'px'}" style="overflow-y: auto;" :class="[{'custom-drag-active': customDragActive}]" @click="changeActiveItem($event.target.parentElement)"  @drop.prevent="onDropEvent" @dragover.prevent="onDragOverEvent" @dragenter.prevent="onDragEnterEvent" @dragleave.prevent="onDragLeaveEvent">
          <div id="loadingContent" class="loadingContent" v-bind:class="{ visible: isLoading }">
            <div class="modal-loadingContent">
              <img class="loading-gif" src="@/assets/images/tramite/loading.gif" alt="loading">
              <p>Cargando...</p>
            </div>
          </div>
          <div v-if="directoryItems.length > 0">
            <div class="directory-item" :id="item.id" :token="item.token" v-for="item in directoryItems" :key="item.id" @dblclick="openFolder($event.target, item.isFile, item.id)" :isFile="item.isFile" :token_base="item.token_base">
              <p style="font-size: 18px;"><font-awesome-icon v-if="item.icon" style="color: background: #1D3662!important;" :icon="item.icon"/></p>
              <p style="padding-left: 10px; width: 70%; padding-top: 3px;" class="truncate-title">{{item.title}}</p>
              <p v-if="!windowWidthEsBaja" style="width: 15%; text-align:right; padding-right: 25px">{{item.dateModified.split(',')[0]}}</p>
              <p v-if="!windowWidthEsBaja" style="width: 15%; text-align:right; padding-right: 25px">{{item.size}} kb</p>
            </div>
          </div>
          <div v-else class="text-center mt-3">
              <p>Seleccione o arrastre sus documentos PDF.</p>
          </div>

        </div>
        <div id="fileManagerFilesRegionBreadcumb" style="background-color: transparent; border-bottom: none; color: #1D3662;">
          <p>Mis Trámites</p>
          <p v-for="item in breadcumb" :key="item.id"><span style="margin-left: 10px;">></span> {{item.title}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios';
import { DxFileManager, DxPermissions, DxUpload } from 'devextreme-vue/file-manager';
import { DxPopup } from 'devextreme-vue/popup'
import LoadPanel from "devextreme-vue/load-panel";
import FileSystemItem from 'devextreme/file_management/file_system_item';
import { locale, loadMessages } from "devextreme/localization";
import CustomFileSystemProvider from 'devextreme/file_management/custom_provider';
import esJson from './es.json'
import { VTree, VSelectTree}  from 'vue-tree-halower'
import rutasjson from "@/assets/utils/rutas.json"
import { Validator } from 'vee-validate';
import es from 'vee-validate/dist/locale/es'
Validator.localize("es", es);

export default {
  components: {
      DxPermissions,
      DxFileManager,
      DxUpload,
      LoadPanel,
      VTree,
      VSelectTree
  },
  props:{
    fileProvider: CustomFileSystemProvider,
    tramiteProp: String,
    tramiteCodProp: String,
  },
  data() {
      return {
        fileProviderData: this.fileProvider,
        fileBrowserInstance: null,
        loaded_directories: [],
        loadingVisibility: false,
        tramite: this.tramiteProp,
        treeData: [{
          title: '',
          expanded: true,
          children: []
        }],
        directoryItems:[],
        treeKey:0,
        isLoading: false,
        filelist: [],
        currentDir:null,
        file:{name:'', data:''},
        promptNewFolder: false,
        promptSureDelete: false,
        newFolderName: '',
        activeItem: null,
        activeNode: null,
        loadedNodes: {},
        breadcumb:[],
        filesRegionHeight: '300',

        customDragActive: false,

        limite_peso_tramite_personal: 10, //10MB
        limite_peso_tramite_empresarial: 20, //20MB

        limite_archivo_individual: 10000000, //10MB
      };
  },
  computed:{
      windowWidthEsBaja(){
          if(this.$store.state.app.windowWidth < 768){
              return true
          }
          return false
      },
  },
  async mounted(){
    this.filesRegionHeight = document.documentElement.clientHeight - 410;
    await axios.get('api/tramite/get-items/',
        {
          params:{
            tramite_token: this.tramiteProp,
            is_file_browser: true
          }
        }
      ).then( response => {
        this.treeData[0].children = response.data.tree_result
        this.directoryItems = response.data.result
        this.treeData[0].title = String(this.tramiteCodProp)
        this.treeData[0].isRoot = true
        this.loadedNodes[0]={treeData: response.data.tree_result, data: response.data.result}
        this.activeNode = this.treeData[0]
        this.breadcumb.push(this.treeData[0])
        this.treeData[0].selected = true
      })
  },
  methods:{
    tpl (...args) {
      let {0: node, 2: parent, 3: index} = args
      let titleClass = node.selected ? 'node-title node-selected' : 'node-title'
      let nodeClass = node.icon=='file-pdf' ? 'no-visible' : ''
      return  <span class={nodeClass} style="display: flex;" onClick={() => this.clickNode(node)}>
                <span style="padding: 3px 2px 3px 6px;">
                  <font-awesome-icon style="color: background: #1D3662!important;" icon={node.icon}/>
                </span>
                <span class={titleClass} domPropsInnerHTML={node.title}></span>
              </span>
    },
    hayError: function(){

        this.$validator.validateAll().then(result => {
                if (result) {
                  // if form have no errors
                  this.addFolder()
                  this.hideModal('modal-agregar-carpeta')
                } else {
                }
              })

    },

    mostrarError(error){
        this.$swal({
          title: 'Error!',
          text: error,
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
          confirmButtonText: 'Aceptar',
        })
    },


    clickNode(node){
      this.activeNode.selected = false
      this.activeNode = node
      this.activeNode.selected = true
      if(!this.isLoading){
        this.isLoading = true
        if(node.isFile){
          this.isLoading = false
        }else{
          if(node.isRoot){
            this.getRoot(false)
          }else{
            this.getItems(node, false)
          }
        }
      }
    },
    async getRoot(forceReload){
      this.isLoading = true
      this.activeItem = null
      this.currentDir = this.treeData[0]
      if(this.loadedNodes[0] && forceReload==false){
        this.directoryItems = this.loadedNodes[0].data
        this.isLoading = false
      }else{
        this.currentDir = null
        this.directoryItems = []
        await axios.get('api/tramite/get-items/',
          {
            params:{
              tramite_token: this.tramite,
            }
          }
        ).then( response => {
          this.treeData[0].children = response.data.tree_result
          this.directoryItems = response.data.result
          this.treeData[0].title = String(this.tramiteCodProp) //String(this.tramite)
          this.treeData[0].isRoot = true
          this.loadedNodes[0]={treeData: response.data.tree_result, data: response.data.result}
          this.isLoading = false
        })
      }
      this.isLoading = false
      this.treeKey++
    },
    volver: async function(){
      if(!this.breadcumb.at(-1).isRoot){
      this.directoryItems = []
      var params = null
      if(this.breadcumb.at(-1).padreKey!=null){
        params = {
          directorio_id: this.activeNode.padreKey,
        }
      }else{
        params = {
          tramite_token: this.tramite
        }
      }
      await axios.get('api/tramite/get-items/',
        {
          params: params
        }
      ).then( response => {
        this.directoryItems = response.data.result
        this.isLoading = false
        this.breadcumb.pop()
      })
      this.treeKey++
      }
    },
    getItems: async function(node, forceReload) {
      this.isLoading = true
      this.activeItem = null
      this.currentDir = node
      if(this.loadedNodes[node.id] && forceReload==false){
        this.directoryItems = this.loadedNodes[node.id].data
        this.isLoading = false
      }else{
        this.directoryItems = []
        await axios.get('api/tramite/get-items/',
          {
            params:{
              directorio_id: node.id,
            }
          }
        ).then( response => {
          node.children = response.data.tree_result
          this.directoryItems = response.data.result
          this.loadedNodes[node.id]={treeData: response.data.tree_result, data: response.data.result}
          node.expanded = true
          this.isLoading = false
        })
      }
      this.isLoading = false
      this.treeKey++
    },
    cargarFilesInputSelect(e, el){
      this.uploadFiles(el.files, el)
    },
    cargarFilesDragAndDrop(e){
      this.uploadFiles(e.dataTransfer.files)
    },
    async uploadFiles(files, el=null){
      this.directoryItems = []
      this.isLoading = true
      for (let file of files) {
        var directorio_padre_param = null
        if(this.currentDir){
          directorio_padre_param = this.breadcumb.at(-1).id
        }
        if (this.verificar_maxsize(file) && this.checkImgExt(file)){
          var tamanio         = this.obtener_tamano_mb(file)
          var condicion_subir = await this.comprobarEspacio(tamanio)
          var condicion_limite_peso_tramite = await this.comprobarLimitePesoTramite(tamanio)

          if(condicion_subir){
            if(condicion_limite_peso_tramite) {
              var fileDict = await this.generar_base64_input(file)
              this.isLoading = true
              await axios.post('api/documento/subir/',
                {
                  name: fileDict.name,
                  content: fileDict.data.split(',')[1],
                  tramite: this.tramite,
                  parent_dir: directorio_padre_param,
                  tamanio: tamanio
                }
              ).then(res => {
                this.isLoading = false
                if(!this.breadcumb.at(-1).isRoot){
                  this.getItems(this.breadcumb.at(-1), true)
                }else{
                  this.getRoot(true)
                }
              })
          }else{
              if(this.$store.state.custom.token_empresa!=null){
                this.mostrarError("No puede agregar más documentos. El tamaño máximo por trámite es de "+ String(this.limite_peso_tramite_empresarial)+" MB.");
              }else{
                this.mostrarError("No puede agregar más documentos. El tamaño máximo por trámite es de "+ String(this.limite_peso_tramite_personal)+" MB.");
              }
              this.refreshFolder();
              this.isLoading = false;
            }
          }else{
            this.mostrarError("No hay espacio disponible en su plan.");
            this.refreshFolder();
            this.isLoading = false
          }

        }else{
          this.refreshFolder();
          this.isLoading = false
        }
      }
      this.isLoading = false
      if(el !== null){
        el.value = ''
      }
    },
    // uploadFile: async function(el){
    //   // console.log("upload file")
    //   this.directoryItems = []
    //   this.isLoading = true
    //   var directorio_padre_param = null
    //   if(this.currentDir){
    //     directorio_padre_param = this.breadcumb.at(-1).id
    //   }
    //   if (el.files[0] && this.verificar_maxsize(el) && this.checkImgExt(el)){
    //     var tamanio         = this.obtener_tamano_mb(el)
    //     var condicion_subir = await this.comprobarEspacio(tamanio)
    //     var condicion_limite_peso_tramite = await this.comprobarLimitePesoTramite(tamanio)
    //
    //     if(condicion_subir){
    //       // console.log("condicion_subir")
    //       if(condicion_limite_peso_tramite) {
    //         // console.log("condicion_limite_peso_tramite")
    //         var file = await this.generar_base64_input(el)
    //         axios.post('api/documento/subir/',
    //           {
    //             name: file.name,
    //             content: file.data.split(',')[1],
    //             tramite: this.tramite,
    //             parent_dir: directorio_padre_param,
    //             tamanio: tamanio
    //           }
    //         ).then(res => {
    //           if(!this.breadcumb.at(-1).isRoot){
    //             this.getItems(this.breadcumb.at(-1), true)
    //           }else{
    //             this.getRoot(true)
    //           }
    //         })
    //     }else{
    //         if(this.$store.state.custom.token_empresa!=null){
    //           this.mostrarError("No puede agregar más documentos. El tamaño máximo por trámite es de "+ String(this.limite_peso_tramite_empresarial)+" MB.");
    //         }else{
    //           this.mostrarError("No puede agregar más documentos. El tamaño máximo por trámite es de "+ String(this.limite_peso_tramite_personal)+" MB.");
    //         }
    //         this.refreshFolder();
    //         this.isLoading = false;
    //       }
    //     }else{
    //       this.mostrarError("No hay espacio disponible en su plan.");
    //       this.refreshFolder();
    //       this.isLoading = false
    //     }
    //
    //   }else{
    //     // console.log("this.isloading=false")
    //     this.refreshFolder();
    //     this.isLoading = false
    //   }
    //   el.value = ''
    //   // console.log("reset input value")
    // },
    addFolder: async function(){
      this.directoryItems = []
      this.isLoading = true
      var directorio_padre_param = null
      this.promptNewFolder = false
      if(this.currentDir){
        directorio_padre_param = this.currentDir.id
      }
      await axios.post('api/directorio/registrar/',
        {
          nombre: this.newFolderName,
          directorio_padre: directorio_padre_param,
          tramite: this.tramiteProp,
        }
      ).then(res => {
          this.newFolderName = ''

          if(this.currentDir!=null){
            this.getItems(this.currentDir, true)
          }else{
            this.getRoot(true)
          }
        }
      )
    },
    changeActiveItem(e){
      if(this.activeItem){
        this.activeItem.classList.remove('active')
      }
      if(e.classList[0] == 'directory-item'){
        e.classList.add('active')
        this.activeItem = e
      }else{
        this.activeItem = null
      }
    },
    openFolder(e, isFile, item){
      if(!isFile){
        this.directoryItems = []
        this.isLoading = true
        e.classList.add('active')
        // var childrenNodes = this.activeNode.children
        var childrenNodes = this.breadcumb.at(-1).children
        for(var i=0; i<childrenNodes.length; i++){
          if(childrenNodes[i].id == item){
            this.activeNode.selected = false
            childrenNodes[i].selected = true
            this.activeNode = childrenNodes[i]
            this.getItems(childrenNodes[i], false)
            this.breadcumb.push(childrenNodes[i])
          }
        }
      }else{
        this.openSelectedFile()
      }
      this.isLoading = false

    },

    deleteActiveItem(){
      this.promptSureDelete = false;
      this.isLoading = true;
      this.directoryItems = []
      axios.post('api/tramite/delete-item/',
        {
          item: this.activeItem.id
        }
      ).then(res => {
        this.refreshFolder()
      })
      this.hideModal('modal-eliminar-carpeta')
    },
    showModalAgregarCarpeta(){
        this.$bvModal.show("modal-agregar-carpeta")
        this.promptNewFolder = true
    },
    showModalDeleteCarpeta(){
        this.$bvModal.show("modal-eliminar-carpeta")
        this.promptSureDelete = true
    },
    hideModal(id){
        this.promptSureDelete = false
        this.promptNewFolder = false
        this.$refs[id].hide()
        this.activeItem = null
    },

    async refreshFolder(){
      // if(this.breadcumb.at(-1)!=true){
      //   this.getItems(this.breadcumb.at(-1), true)
      // }else{
      //   this.getRoot(true)
      // }
      this.isLoading = true
      this.directoryItems = []
      var params = null
      if(!this.breadcumb.at(-1).isRoot){
        params = {
          directorio_id: this.activeNode.id,
        }
      }else{
        params = {
          tramite_token: this.tramite
        }
      }
      await axios.get('api/tramite/get-items/',
        {
          params: params
        }
      ).then( response => {
        this.directoryItems = response.data.result
        this.isLoading = false
      })
      this.treeKey++
    },
    renameItem: async function(item, name) {
        await axios.post('api/tramite/edit-item/',
          {
            item: item.key
          }
        ).then( response => {}
        );
        let promise = new Promise(function(resolve, reject) {
            resolve();
        });
        return promise
    },
    openSelectedFile(){
      window.open(rutasjson.documentos + this.activeItem.getAttribute('token') + "_" + this.activeItem.getAttribute('token_base'))
    },

    async comprobarEspacio(tamanio_archivo){
        var my_boolean= null;
        await axios.post('api/plan/comprobar_espacio/',
            {
             tamano_archivo:tamanio_archivo
            }
             ).then( response => {
                my_boolean= response.data.espacio_disponible
                });
        return my_boolean;
    },

    async comprobarLimitePesoTramite(tamanio_archivo){
        var my_boolean= null;
        await axios.post('api/tramite/comprobar_peso_total/', {
            tamano_archivo:tamanio_archivo,
            tramite: this.tramite,
        }
        ).then( response => {
            my_boolean= response.data.data;
        });
        return my_boolean;
    },

    verificar_maxsize(file){
      // var maxSize = el.getAttribute('data-max-size');
      // maxSize = parseInt(maxSize);
      // var maxSize = parseInt(maxSize)
      if(file){
        var fileSize = file.size; // in bytes
        if(fileSize>this.limite_archivo_individual){
          this.mostrarError('El archivo es demasiado grande. El archivo no debe pesar más de ' + (this.limite_archivo_individual/1000000).toString().split(".")[0] + ' MB.')
          return false;
        }else{
          return true;
        }
      }
    },

    obtener_tamano_mb(file){
       var fileSize = file.size;
       return fileSize/this.limite_archivo_individual;
    },


    checkImgExt(file){
      let filename = (file.name).split('.'); // nombre del archivo en str
      var ext = filename[filename.length-1];
      if(ext!='pdf' && ext!='PDF'){
        this.mostrarError('Archivo no permitido. Elija un archivo PDF.')
        return false
      }
      return true
    },

    async generar_base64_input(file) {
        let name_elemento 	= file.name
        let file_base64 	  = await this.get_data_base64(file) //archivo en base64

        var fileDict = {name: name_elemento, data: file_base64}
        return fileDict
    },

    async get_data_base64(file) {
      return new Promise(resolve => {
        let reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onload = function () {
          var resB64str = reader.result;
          resolve(resB64str);
        };
        reader.onerror = function (error) {
        };
      })
    },

    onDropEvent(e){
      this.customDragActive = false
      this.cargarFilesDragAndDrop(e)
    },
    onDragOverEvent(){
      this.customDragActive = true
    },
    onDragEnterEvent(){
      this.customDragActive = true
    },
    onDragLeaveEvent(){
      this.customDragActive = false
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/extraComponents/tree.scss";

.halo-tree .node-title{
  margin: 0px !important;
}

.tree-expand{
  margin: 5px 0px 0px 1px !important;
}

.tree-node-el{
  display: flex !important;
  background-color: transparent !important;
}

.tree-box{
  background: #fff;
  position: relative;
  z-index: 9;
}

.rmNode{
  background-color: rgba(var(--vs-danger),0.15);
  color: rgba(var(--vs-danger),1);
  line-height: 13px;
}

.node-selected{
  border: none !important;
  background-color: none !important;
}
</style>

<style>
.photo-popup-content {
    text-align: center;
}
.photo-popup-content .photo-popup-image {
    height: 100%;
    max-width: 100%;
}

.button-container{
    margin-top: 10px;
    margin-left: auto;
    margin-right: auto;
    display: block;
    width: fit-content;
}

.fileManager2Bajo{
  width: 100%;
  min-width: 400px;
}

.fileManager2Alto{
  width: 100%;
  min-width: 800px;
}

#fileManagerHeader{
  width: 100%;
  height: 50px;
  display: flex;
  padding: 6px 10px;
  border-radius: 12px 12px 0 0;
  border-top: #1D3662 solid 2px;
  border-left: #1D3662 solid 2px;
  border-right: #1D3662 solid 2px;
  background-color: #1D3662;
  color: white;

}

#fileManagerHeader p{
  font-size: 18px;
}

#fileManagerContent{
  height: 100%;
  display: flex;
}

#fileManagerFilesTree{
  height: 500px;
  width:30%;
  padding: 0px 0px 0px 10px;
  background-color: #536d9b1f;
  display: none !important
}

#fileManagerFilesRegion{
  width: 100%;
  height: fit-content;
  color: #333;
  background-color: white;
  border-radius: 0 0 12px 12px;
  border: solid 2px #1D3662;
  border-top: none;
}

#fileManagerFilesRegionBreadcumb{
  width: 100%;
  background-color: white;
  padding: 8px 0px 8px 45px;
  display: flex;
  border: #1D3662 solid 1px;
  border-right: none;
  border-left: none;
}

.directory-item{
  padding: 7px 0px 7px 20px;
  display: flex;
  width: 100%;
  cursor: pointer;
  z-index: 100;
}

.directory-item.active{
  background-color: #3E5379;
  color: white;
}

.directory-item p{
  font-size: 14px;
  z-index: 1;
}

.halo-tree{
  padding-top: 10px;
}

.tree-node-el .node-title{
  font-size: 14px;
}

.header-option:hover{
  cursor: pointer !important;
  color: rgb(103, 149, 164)
}

.halo-tree .halo-tree li{
  padding-left: 12px !important;
}

#fileManagerFilesTree > .halo-tree{
  height: 100% !important;
  overflow-x: hidden !important;
  overflow-y: scroll !important;
  color: black;
}

/* The Modal (background) */
.loadingContent {
  display: none; /* Hidden by default */
  z-index: 1; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 94%; /* Full height */
  overflow: hidden; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

/* Modal Content/Box */
.modal-loadingContent {
  background-color: #fefefe;
  margin: 12% auto; /* 12% from the top and centered */
  padding: 3%;
  border: 1px solid #888;
  width: 25%; /* Could be more or less, depending on screen size */
  height: 30%;
  text-align: center;
  font-size: 20px;
  /* font-weight: bold; */
  border-radius: 7px;
  max-height: 175px;
}

.halo-tree .node-selected {
  background-color: #1D3662 !important;
  color: white !important;
}

li.leaf::before{
  border: none !important;
}

li.leaf::after{
  border: none !important;
}

li::after{
  border: none !important;
}

.tree-close{
  display: none;
}

.halo-tree li:before{
  display: none;
}

label.custom-file-label::after{
  display: none!important;
}

.custom-drag-active{
  border-style: dashed;
  border-color: #1D3662;
  opacity: 0.2;
}

.truncate-title{
  overflow: hidden; text-overflow: ellipsis;
}
</style>
